<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <el-row>
      <label style="font-size: 25px" v-if="EmploySelectedName">
        Empleado:
        <b> {{ this.EmploySelectedName }}</b>
      </label>
      <!-- <el-col :span="8">
        <table style="font-size: 25px" id="table-card">
          <tr style="font-size: 25px">
            <td>Empleado:</td>
            <td>
              <strong> {{ this.EmploySelectedName }} </strong>
            </td>
          </tr>
        </table>
      </el-col> -->

      <!-- <el-col :span="4">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Total {{ totalTitle }}:</td>
            <td>
              <strong> {{ itemQuantity }} </strong>
            </td>
          </tr>
        </table>
      </el-col> -->

      <el-col
        :span="6"
        :offset="2"
        v-if="isVisita === true || isLlamada === true"
      >
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Eficiencia:</td>
            <td>
              <strong :class="{ Rojo: rojo, Naranja: naranja, Verde: verde }">
                {{ Eficiencia }} %
              </strong>
            </td>
          </tr>
        </table>
      </el-col>
      <!-- lo que estoy modificando de clientes con app -->
      <el-col
        :span="6"
        :offset="2"
        v-if="
          Title === 'Clientes sin App' ||
          Title === 'Clientes sin Portal' ||
          Title === 'Clientes sin Portal y sin APP'
        "
      >
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Total de Clientes con Contactos:</td>
            <td>
              <strong :class="{ Rojo: rojo, Naranja: naranja, Verde: verde }">
                {{ TotalContacts }}
              </strong>
            </td>
          </tr>
        </table>
      </el-col>

      <!-- <el-col :span="6" :offset="2" v-if="`${totalAmount}`.includes('.')">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Total Monto:</td>
            <td>
              <strong> {{ totalAmount | formatterMoney }}</strong>
            </td>
          </tr>
        </table>
      </el-col> -->
    </el-row>
    <el-form
      class="form"
      ref="form"
      label-width="125px"
      :label-position="'left'"
    >
      <el-col
        style="font-size: 20px"
        v-if="
          itemQuantity &&
          Title !== 'Clientes sin App' &&
          Title !== 'Clientes sin Portal' &&
          Title !== 'Clientes sin Portal y sin APP'
        "
      >
        <el-col :span="24" class="col-p">
          Total de {{ Title }}:
          <el-input style="font-size: 19px" v-model="itemQuantity" disabled />
        </el-col>
      </el-col>
      <el-col
        style="font-size: 20px"
        v-if="`${totalAmount}`.includes('.') && status !== 'kpi'"
      >
        <el-col :span="24" class="col-p">
          Total Monto:
          <el-input
            style="font-size: 19px"
            :value="$options.formatMonto(totalAmount)"
            disabled
          />
        </el-col>
      </el-col>
      <!-- <el-col style="font-size: 20px" v-if="totalInvoice">
        <el-col :span="24" class="col-p">
          Total de facturas:
          <el-input style="font-size: 19px" v-model="totalInvoice" disabled />
        </el-col>
      </el-col> -->

      <el-col
        style="font-size: 20px"
        v-for="(item, key) in Items"
        :key="key"
        :span="24"
        class="col-p"
      >
        Cantidad de Facturas a <b :class="item.Class"> {{ key }} </b> Días:
        <el-input style="font-size: 19px" v-model="item.Cantidad" disabled />

        Montos:
        <el-input
          style="font-size: 19px"
          :value="$options.formatMonto(item.Monto)"
          disabled
        />
      </el-col>

      <el-col> </el-col>
    </el-form>

    <!-- <div id="el-row-dayInvoice">
      <label
        style="font-size: 25px"
        v-for="(item, key) in totalItems"
        :key="item"
      >
        Cantidad de Facturas a <b :class="item.Class"> {{ key }} </b> Días:
        <b> {{ item.Cantidad }}</b> Monto:
        <b> {{ $options.formatMonto(item.Monto) }}</b>
      </label>
    </div> -->

    <!-- <table
      style="font-size: 25px; width: 1000px; display: inline-block"
      id="table-card"
    >
      <tr v-for="(item, key) in totalItems" :key="item">
        <td>Cantidad de Facturas a {{ key }}</td>
        <td>
          Días: <strong> {{ item.Cantidad }}</strong>
        </td>
        <td>
          Monto: <strong> {{ item.Monto }}</strong>
        </td>
      </tr>
    </table> -->

    <el-row>
      <el-col :span="3" v-if="totalTitle === 'Tareas'">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Total Dias:</td>
            <td>
              <strong> {{ diasTotal }} </strong>
            </td>
          </tr>
        </table>
      </el-col>

      <el-col :span="4" :offset="1" v-if="totalTitle === 'Tareas'">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Total Horas:</td>
            <td>
              <strong> {{ horasTotal }} </strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row v-if="`${totalAmount}`.includes('.')">
      <el-col :span="8" v-if="`${totalYearlyAmount}`.includes('.')">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Total Monto Anual:</td>
            <td>
              <strong> {{ totalYearlyAmount | formatterMoney }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :span="8" v-if="`${totalMonthlyAmount}`.includes('.')">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>Total Monto Mensual:</td>
            <td>
              <strong> {{ totalMonthlyAmount | formatterMoney }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>

    <el-row
      class="rowVisitasLlamadas"
      v-if="isVisita === true || isLlamada === true"
    >
      <el-col :span="4" v-if="`${totalContactado_A}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes {{ isVisitaOLlamadaLabel }} Tipo A:</td>
            <td>
              <strong> {{ totalContactado_A }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :offset="4" :span="4" v-if="`${totalNoContactado_A}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes No {{ isVisitaOLlamadaLabel }} Tipo A:</td>
            <td>
              <strong> {{ totalNoContactado_A }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row
      class="rowVisitasLlamadas"
      v-if="isVisita === true || isLlamada === true"
    >
      <el-col :span="4" v-if="`${totalContactado_B}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes {{ isVisitaOLlamadaLabel }} Tipo B:</td>
            <td>
              <strong> {{ totalContactado_B }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :offset="4" :span="4" v-if="`${totalNoContactado_B}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes No {{ isVisitaOLlamadaLabel }} Tipo B:</td>
            <td>
              <strong> {{ totalNoContactado_B }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row
      class="rowVisitasLlamadas"
      v-if="isVisita === true || isLlamada === true"
    >
      <el-col :span="4" v-if="`${totalContactado_C}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes {{ isVisitaOLlamadaLabel }} Tipo C:</td>
            <td>
              <strong> {{ totalContactado_C }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :offset="4" :span="4" v-if="`${totalNoContactado_C}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes No {{ isVisitaOLlamadaLabel }} Tipo C:</td>
            <td>
              <strong> {{ totalNoContactado_C }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row
      class="rowVisitasLlamadas"
      v-if="isVisita === true || isLlamada === true"
    >
      <el-col :span="4" v-if="`${totalContactado_D}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes {{ isVisitaOLlamadaLabel }} Tipo D:</td>
            <td>
              <strong> {{ totalContactado_D }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :offset="4" :span="4" v-if="`${totalNoContactado_D}` >= 0">
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Clientes No {{ isVisitaOLlamadaLabel }} Tipo D:</td>
            <td>
              <strong> {{ totalNoContactado_D }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <!--
    <el-row  class="rowVisitasLlamadas" v-if="isLlamada=== true">
      <el-col :span="4" v-if="`${totalContactado_E}` >= 0">
        <table style="font-size: 15px" class="headersVisitasOLlamadas" id="table-card">
          <tr>
            <td>Clientes {{isVisitaOLlamadaLabel}} Tipo E:</td>
            <td>
              <strong> {{ totalContactado_E }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :offset="4" :span="4" v-if="`${totalNoContactado_E}` >= 0">
        <table style="font-size: 15px" class="headersVisitasOLlamadas" id="table-card">
          <tr>
            <td>Clientes No {{isVisitaOLlamadaLabel}} Tipo E:</td>
            <td>
              <strong> {{ totalNoContactado_E }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row  class="rowVisitasLlamadas" v-if="isLlamada=== true">
      <el-col :span="4" v-if="`${totalContactado_F}` >= 0">
        <table style="font-size: 15px" class="headersVisitasOLlamadas" id="table-card">
          <tr>
            <td>Clientes {{isVisitaOLlamadaLabel}} Tipo F:</td>
            <td>
              <strong> {{ totalContactado_F }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :offset="4" :span="4" v-if="`${totalNoContactado_F}` >= 0">
        <table style="font-size: 15px" class="headersVisitasOLlamadas" id="table-card">
          <tr>
            <td>Clientes No {{isVisitaOLlamadaLabel}} Tipo F:</td>
            <td>
              <strong> {{ totalNoContactado_F }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    -->
    <el-row v-if="isVisita === true || isLlamada === true">
      <el-col :span="4" v-if="`${totalContactado}` >= 0">
        <el-divider class=".rowVisitasLlamadas"></el-divider>
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Total Clientes {{ isVisitaOLlamadaLabel }}:</td>
            <td>
              <strong> {{ totalContactado }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :offset="4" :span="4" v-if="`${totalNoContactado}` >= 0">
        <el-divider class=".rowVisitasLlamadas"></el-divider>
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Total Clientes No {{ isVisitaOLlamadaLabel }}:</td>
            <td>
              <strong> {{ totalNoContactado }}</strong>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>

    <el-row
      v-if="
        Title === 'Clientes sin App' ||
        Title === 'Clientes sin Portal' ||
        Title === 'Clientes sin Portal y sin APP'
      "
    >
      <el-col
        :span="4"
        v-if="
          `${TotalContactsWithApp}` >= 0 &&
          (Title === 'Clientes sin App' ||
            Title === 'Clientes sin Portal y sin APP')
        "
      >
        <!-- <el-divider class=".rowVisitasLlamadas"></el-divider> -->
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Total Clientes Con App:</td>
            <td>
              <strong> {{ TotalContactsWithApp }} </strong>
            </td>
          </tr>
          <tr>
            <td>Total Clientes Sin App:</td>
            <td>
              <strong> {{ totalContactWithoutApp }} </strong>
            </td>
          </tr>
          <tr>
            <td>Porcentaje Clientes Sin App:</td>
            <td>
              <strong
                :class="{ Rojo: rojoCWA, Naranja: naranjaCWA, Verde: verdeCWA }"
              >
                {{ PercentContactsWithApp }} %</strong
              >
            </td>
          </tr>
        </table>
      </el-col>
      <el-col
        :span="4"
        v-if="
          `${TotalContactsWithPortal}` >= 0 &&
          (Title === 'Clientes sin Portal' ||
            Title === 'Clientes sin Portal y sin APP')
        "
      >
        <!-- <el-divider class=".rowVisitasLlamadas"></el-divider> -->
        <table
          style="font-size: 15px"
          class="headersVisitasOLlamadas"
          id="table-card"
        >
          <tr>
            <td>Total Clientes Con Portal:</td>
            <td>
              <strong> {{ TotalContactsWithPortal }} </strong>
            </td>
          </tr>
          <tr>
            <td>Total Clientes sin Portal:</td>
            <td>
              <strong> {{ TotalContactsWithoutPortal }} </strong>
            </td>
          </tr>
          <tr>
            <td>Porcentaje Clientes Sin Portal:</td>
            <td>
              <strong
                :class="{ Rojo: rojoCWP, Naranja: naranjaCWP, Verde: verdeCWP }"
              >
                {{ PercentContactsWithPortal }} %</strong
              >
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { formatMonto } from "@/utils";

export default {
  name: "CardStatDrawerHeader",
  formatMonto,
  props: {
    employee: {
      type: [String, Number]
    },
    EmploySelectedName: {
      type: String
    },
    itemQuantity: {
      type: Number,
      default: 0
    },
    diasTotal: {
      type: Number,
      default: 0
    },
    horasTotal: {
      type: Number,
      default: 0
    },
    headerTitle: {
      type: String,
      default: ""
    },
    totalAmount: {
      type: [String, Number],
      default: ""
    },
    totalInvoice: {
      type: [String, Number],
      default: ""
    },
    totalItems: {
      type: Object
    },
    totalYearlyAmount: {
      type: String,
      default: ""
    },
    totalMonthlyAmount: {
      type: String,
      default: ""
    },
    totalCliente: {
      type: Number,
      default: 0
    },
    Eficiencia: {
      type: Number,
      default: 0
    },
    totalContactado: {
      type: Number,
      default: 0
    },
    totalNoContactado: {
      type: Number,
      default: 0
    },
    totalContactado_A: {
      type: Number,
      default: 0
    },
    totalNoContactado_A: {
      type: Number,
      default: 0
    },
    totalContactado_B: {
      type: Number,
      default: 0
    },
    totalNoContactado_B: {
      type: Number,
      default: 0
    },
    totalContactado_C: {
      type: Number,
      default: 0
    },
    totalNoContactado_C: {
      type: Number,
      default: 0
    },
    totalContactado_D: {
      type: Number,
      default: 0
    },
    totalNoContactado_D: {
      type: Number,
      default: 0
    },
    /*
    totalContactado_E: {
      type: Number,
      default: 0
    },
    totalNoContactado_E: {
      type: Number,
      default: 0
    },
    totalContactado_F: {
      type: Number,
      default: 0
    },
    totalNoContactado_F: {
      type: Number,
      default: 0
    },
    */
    isVisitaOLlamadaLabel: {
      type: String,
      default: ""
    },
    isVisita: {
      type: Boolean,
      default: false
    },
    isLlamada: {
      type: Boolean,
      default: false
    },
    Title: {
      type: String,
      default: ""
    },
    TotalContactsWithApp: {
      type: Number,
      default: 0
    },
    totalContactWithoutApp: {
      type: Number,
      default: 0
    },
    TotalContactsWithPortal: {
      type: Number,
      default: 0
    },
    TotalContactsWithoutPortal: {
      type: Number,
      default: 0
    },
    TotalContacts: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      rojo: false,
      naranja: false,
      verde: false,
      PercentContactsWithApp: 0,
      PercentContactsWithPortal: 0,
      rojoCWA: false,
      naranjaCWA: false,
      verdeCWA: false,
      rojoCWP: false,
      naranjaCWP: false,
      verdeCWP: false,
      totalTitle: ""
    };
  },
  created() {
    if (this.headerTitle.includes("Tareas") == true) {
      this.totalTitle = "Tareas";
    } else if (this.headerTitle.includes("Solicitudes") == true) {
      this.totalTitle = "Solicitudes";
    } else if (this.headerTitle.includes("Quejas") == true) {
      this.totalTitle = "Quejas";
    } else if (this.headerTitle.includes("Contratos") == true) {
      this.totalTitle = "Contratos";
    } else if (this.headerTitle.includes("Citas") == true) {
      this.totalTitle = "Citas";
    } else if (this.headerTitle.includes("Instalaciones") == true) {
      this.totalTitle = "Instalaciones";
    } else if (this.headerTitle.includes("Oportunidades") == true) {
      this.totalTitle = "Oportunidades";
    } else {
      this.totalTitle = "Clientes";
    }
  },
  computed: {
    User: function () {
      if (!this.$store.state.productivity.chosenUserName) {
        return this.$store.state.user.user.FullName;
      } else {
        // Returns the name of the user chosen by the "super user"
        return this.$store.state.productivity.chosenUserName;
      }
    },
    Items() {
      let items = this.totalItems.filter((i) => i.Cantidad > 0);
      return items;
    }
  },
  watch: {
    Eficiencia: function () {
      if (
        this.Eficiencia == "0" ||
        (this.Eficiencia >= 0 && this.Eficiencia < 80)
      ) {
        this.rojo = true;
      }
      if (this.Eficiencia >= 80 && this.Eficiencia < 90) {
        this.naranja = true;
      }
      if (this.Eficiencia >= 90) {
        this.verde = true;
      }
    },
    headerTitle: function () {
      if (this.headerTitle.includes("Tareas") == true) {
        this.totalTitle = "Tareas";
      } else if (this.headerTitle.includes("Solicitudes") == true) {
        this.totalTitle = "Solicitudes";
      } else if (this.headerTitle.includes("Quejas") == true) {
        this.totalTitle = "Quejas";
      } else if (this.headerTitle.includes("Contratos") == true) {
        this.totalTitle = "Contratos";
      } else if (this.headerTitle.includes("Citas") == true) {
        this.totalTitle = "Citas";
      } else if (this.headerTitle.includes("Instalaciones") == true) {
        this.totalTitle = "Instalaciones";
      } else if (this.headerTitle.includes("Oportunidades") == true) {
        this.totalTitle = "Oportunidades";
      } else {
        this.totalTitle = "Clientes";
      }
    },
    totalContactWithoutApp: function () {
      this.PercentContactsWithApp = Math.round(
        (this.totalContactWithoutApp / this.itemQuantity) * 100
      );

      if (
        this.PercentContactsWithApp == "0" ||
        (this.PercentContactsWithApp >= 0 && this.PercentContactsWithApp < 10)
      ) {
        this.verdeCWA = true;
      }
      if (
        this.PercentContactsWithApp >= 10 &&
        this.PercentContactsWithApp < 20
      ) {
        this.naranjaCWA = true;
      }
      if (this.PercentContactsWithApp >= 20) {
        this.rojoCWA = true;
      }
    },

    TotalContactsWithoutPortal: function () {
      this.PercentContactsWithPortal = Math.round(
        (this.TotalContactsWithoutPortal / this.itemQuantity) * 100
      );
      if (
        this.PercentContactsWithPortal == "0" ||
        (this.PercentContactsWithPortal >= 0 &&
          this.PercentContactsWithPortal < 10)
      ) {
        this.verdeCWP = true;
      }
      if (
        this.PercentContactsWithPortal >= 10 &&
        this.PercentContactsWithPortal < 20
      ) {
        this.naranjaCWP = true;
      }
      if (this.PercentContactsWithPortal >= 20) {
        this.rojoCWP = true;
      }
    }
  }
};
</script>
<style scoped>
.headersVisitasOLlamadas {
  padding: 0;
  margin: 0;
}
.rowVisitasLlamadas {
  padding: 0;
  margin: 0;
}
#el-row-dayInvoice {
  padding-top: 5px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.Azul {
  color: blue;
}
.Verde {
  color: green;
}
.Naranja {
  color: orange;
}
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}
.form {
  display: grid;
  grid-row-gap: 25px;
  justify-content: center;
  grid-template-columns: 30% 30% 30%;
}
</style>
